// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"344":"0b3b07c1","398":"68ed6faa"}[chunkId] + ".css";
};